
import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DayType } from '../../service/day-type.dto';
import { StpImporterService } from '../../service/importer-stp.service';

@Component({
  // eslint-disable-next-line  @angular-eslint/component-selector
  selector: 'importer-stp-day-type-selector',
  templateUrl: './day-type-selector.component.html',
  styleUrls: ['./day-type-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DayTypeSelectorComponent),
      multi: true
    }
  ]
})
export class DayTypeSelectorComponent implements ControlValueAccessor {
  @Input() type: 'kppId' | 'name' = 'name';

  availableDaytypes: DayType[] = [];
  value: string[] | number[] | null = null;
  disabled: boolean = false;

  onChange: any = () => { };
  onTouched: any = () => { };

  constructor(private importerService: StpImporterService) { }

  @Input() set carrierId(carrierId: null | number) {
    if (carrierId != null) {
      this.importerService.getAllDayTypes(carrierId)
        .subscribe(s => this.availableDaytypes = s);
    } else {
      this.availableDaytypes = [];
      this.onSelectChange(null);
    }
  };

  getOptionValue(item: DayType): any {
    return this.type ? item[this.type] : item;
  }

  writeValue(value: string[] | number[] | null): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onSelectChange(value: string[] | number[] | null): void {
    this.value = value;
    this.onChange(value);
  }

}
